import { Getter, GetterTree } from "vuex";
import { RootState } from "@/store/RootState";
import { SettingsGetters, SettingsState } from "@/components/settings/types";

export const getters: GetterTree<SettingsState, RootState> &
  Record<SettingsGetters, Getter<SettingsState, RootState>> = {
  [SettingsGetters.getSettingsPageTitle](state) {
    return state.settingsPageTitle;
  },
  [SettingsGetters.getPinOverlay](state) {
    return state.openPinOverlay;
  },
  [SettingsGetters.getEncodedPin](state) {
    return state.encodedPin;
  },
  [SettingsGetters.getOpenRightSideMenu](state) {
    return state.openRightSideMenu;
  },
  [SettingsGetters.getActiveCardIndex](state) {
    return state.activeCardIndex;
  },
  [SettingsGetters.getActiveCardSection](state) {
    return state.activeCardSection;
  },
  [SettingsGetters.getActiveCardSection](state) {
    return state.activeCardSection;
  },
  [SettingsGetters.getRightSideMenuTitle](state) {
    return state.rightSideMenuTitle;
  },
  [SettingsGetters.getUserToEdit](state) {
    return state.userToEdit;
  },
  [SettingsGetters.getConfirmModalStatus](state) {
    return state.confirmModalStatus;
  },
  [SettingsGetters.getOpenConfirmModal](state) {
    return state.openConfirmModal;
  },
  [SettingsGetters.getConfirmModalMsg](state) {
    return state.confirmModalMsg;
  },
  [SettingsGetters.getChannelCardCurrPos](state) {
    return state.channelCardCurrPos;
  },
  [SettingsGetters.getChannelCardNewPos](state) {
    return state.channelCardNewPos;
  }
};
